import '../../common/simplero_image_preloader/index'
import '../../common/image_transitioner/index'
import { preload } from '../../common/image_transitioner/preload'

class FeatureToggler {
  constructor(elm) {
    this.autoToggleNextFeature = this.autoToggleNextFeature.bind(this)
    this.onToggle = this.onToggle.bind(this)
    this.toggleFeature = this.toggleFeature.bind(this)
    this.inView = this.inView.bind(this)
    this.viewPortHeight =
      window.innerHeight || document.documentElement.clientHeight
    this.elm = elm
    this.transitionerId = this.elm.querySelector(
      '.image-transitioner'
    ).dataset.transitionerId
    this.toggles = Array.from(
      this.elm.querySelectorAll('a[data-toggle-feature]')
    )
    this.toggles.forEach((toggle) => {
      toggle.addEventListener('click', this.onToggle)
      toggle.addEventListener('mouseover', () =>
        preload(this.featureElement(toggle))
      )
      toggle.addEventListener(
        'touchstart',
        () => preload(this.featureElement(toggle)),
        { passive: true }
      )
    })
    this.autoToggleInterval = setInterval(this.autoToggleNextFeature, 3000)
  }

  autoToggleNextFeature() {
    if (this.inView()) {
      this.toggleFeature(this.getNext())
    }
  }

  getNext() {
    let next = this.toggles
      .filter((toggle) => toggle.classList.contains('feature--active'))
      .map((toggle) => toggle.nextElementSibling)
      .filter((el) => el && el.tagName.toLowerCase() == 'a')
    if (next.length === 0) {
      return this.toggles[0]
    }
    return next[0]
  }

  onToggle(e) {
    e.preventDefault()
    clearInterval(this.autoToggleInterval)
    this.toggleFeature(e.target)
  }

  toggleFeature(toggle) {
    if (toggle.classList.contains('feature--active')) {
      return
    }

    this.toggles.forEach((otherToggle) => {
      otherToggle.classList.remove('feature--active')
    })
    toggle.classList.add('feature--active')

    const featureElm = this.featureElement(toggle)
    const transitioner = window.imageTransitioners[this.transitionerId]
    transitioner.$set(
      window.imageTransitioners.constructPropsFromDataAttrs(featureElm)
    )

    preload(this.featureElement(this.getNext()))
  }

  featureElement(toggle) {
    const featurePos = toggle.dataset.toggleFeature
    return this.elm.querySelector(`div[data-feature-position='${featurePos}']`)
  }

  inView() {
    const boundingRect = this.elm.getBoundingClientRect()
    return boundingRect.top > 0 && boundingRect.bottom < this.viewPortHeight
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('.simplero-new-feature-toggler__container')
    .forEach((e) => new FeatureToggler(e))
})
